import { Buffer } from "buffer";

export const getClientInfo = (): string => {
  const info = {
    userAgent: navigator.userAgent,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    screenColorDepth: window.screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    cpuClass: navigator.hardwareConcurrency,
  };
  return Buffer.from(Object.values(info).join("|")).toString("base64");
};
